import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Submenu',
  setup(__props) {
    const route = useRoute();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(NavBarMenu, null, {
        default: _withCtx(() => [_createVNode(NavBarMenuItem, {
          to: {
            name: 'competitions.cup',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.ScoreboardOutlined,
          label: _ctx.$t('matches')
        }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
          to: {
            name: 'competitions.player-competition-logs',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.ScoreboardOutlined,
          label: _ctx.$t('player_stats')
        }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
          to: {
            name: 'competitions.index'
          },
          icon: _ctx.IconEnum.World,
          label: _ctx.$t('competitions')
        }, null, 8, ["to", "icon", "label"])]),
        _: 1
      });
    };
  }
});